<template>
	<div id="content" class="content join join_done">
		<div class="container">
			<a class="hide-login-image" id="appleid-signin" style="width: 1px;" data-border="true" data-type="sign in"></a>
			<div class="page-title">
				<h2 class="tit">APPLE 로그인 진행중</h2>
				<p class="sub-tit">APPLE 인증이 진행중입니다. 잠시만 기다려 주세요.</p>
				<input class="inp-id" type="text" id="deviceToken" v-show="LOCAL === 'localhost'" placeholder="장치 토큰" readonly="readonly">
			</div>
		</div>
	</div>
</template>

<script>
import webUtils from "@/commons/utils/web.utils";

export default {
	name: "appleReturn",
	data() {
		return{
			LOCAL: location.hostname,
			isLoaded: false
		}
	},
	created() {
		const self = this
		this.$loadScript("https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js").then(() => {
			$('#appleid-signin').hide()

			window.AppleID.auth.init({
				clientId: "com.ssflex.app.web",
				scope: "name email",
				redirectURI: this.APIs.APPLE_LOGIN_RETURN,
				state: "origin:web",
				usePopup: true,
			});

			self.isLoaded = true

			document.addEventListener('AppleIDSignInOnSuccess', (data) => {
				this.callBackAppleLogin(data)
			});

			document.addEventListener('AppleIDSignInOnFailure', (e) => {

				// if (e.detail.error === "popup_closed_by_user") {
				// 	const delegateDomain = self.$route.params.subDomain
				//
				// 	self.axiosCaller.get(self, self.APIs.SNS_APPLE + "/doSnsLogin", {
				// 		snsService: "apple",
				// 		snsId: "000686.dad1266e58474f8c873a28b504796298.0450",
				// 		email: "pjy@humanwares.com",
				// 		name: "박준영",
				// 		deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				// 		LOGIN_DOMAIN: delegateDomain,
				// 		coCode: delegateDomain
				// 	}, async (res) => {
				// 		const result = res.data
				// 		console.log(result)
				//
				// 		if ( result.status === "integrated_login" ) {
				// 			self.swalUtils.fire("계정 통합", result.msg, "info")
				// 				.then(async swalResult => {
				// 					console.log(swalResult)
				// 					if (swalResult.isConfirmed || swalResult.dismiss) {
				// 						if (await self.setSessionProc(result.coAccountVO)) {
				// 							self.setSessionKeep(self.isKeepSession)
				// 							if (window.opener) {
				// 								self.$session.destroy()
				// 								self.$nextTick(() => {
				// 									window.opener.postMessage({ key: "apple", account: result.coAccountVO }, location.origin.replace(webUtils.getSubdomainWithURLString(location.href), delegateDomain))
				// 									window.opener.focus()
				// 									close()
				// 								})
				// 							} else {
				// 								self.goWithCoCode(self)
				// 							}
				// 						}
				// 					}
				// 				});
				// 			return
				// 		}
				//
				// 		if (result.status === "login") {
				// 			if (await self.setSessionProc(result.coAccountVO)) {
				// 				self.setSessionKeep(self.isKeepSession);
				// 				if (window.opener) {
				// 					self.$session.destroy()
				// 					window.opener.postMessage({ key: "apple", account: result.coAccountVO }, location.origin.replace(webUtils.getSubdomainWithURLString(location.href), delegateDomain))
				// 					self.$nextTick(() => {
				// 						window.opener.focus()
				// 						close()
				// 					})
				// 				} else {
				// 					self.goWithCoCode(self)
				// 				}
				// 			}
				// 		} else {
				// 			if (window.opener) {
				// 				window.opener.postMessage({
				// 					"key": "alert",
				// 					"icon": "info",
				// 					"title": "Error",
				// 					"content": result.msg
				// 				}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), delegateDomain))
				// 				self.$nextTick(() => {
				// 					window.opener.focus()
				// 					close()
				// 				})
				// 			} else {
				// 				self.swalUtils.gritter("Error", result.msg, "question", 1500, () => {
				// 					history.back()
				// 				})
				// 			}
				// 		}
				// 	})
				// }

				if (window.opener) {
					window.opener.postMessage({
						"key": "alert",
						"icon": "info",
						"title": "Error",
						"content": e.detail.error
					}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), self.$route.params.subDomain))
					self.$nextTick(() => {
						close()
					})
				} else {
					self.swalUtils.gritter("Error", e.detail.error, "question", 1500, () => {
						history.back()
					})
				}
			})
			this.appDeviceToken("#deviceToken")
		})
	},
	mounted() {
		// setTimeout(() => {
		// 	document.querySelector('#appleid-signin').click()
		// }, 5000)
	},
	methods: {
		callBackAppleLogin(_result) {
			// "eyJraWQiOiI4NkQ4OEtmIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLnNzZmxleC5hcHAud2ViIiwiZXhwIjoxNjM4MzIxMTIwLCJpYXQiOjE2MzgyMzQ3MjAsInN1YiI6IjAwMDA1Mi42ZjdhODIwODU1MWM0ODU3YmRlZTljNDA2OWMzOWExOS4wMDMzIiwiY19oYXNoIjoiMVBUX3A5Q3BYYWVSQ29jV0RKUkVwQSIsImVtYWlsIjoia2hhbmUwOTA3QGdtYWlsLmNvbSIsImVtYWlsX3ZlcmlmaWVkIjoidHJ1ZSIsImF1dGhfdGltZSI6MTYzODIzNDcyMCwibm9uY2Vfc3VwcG9ydGVkIjp0cnVlfQ.euASmIA1XVuXQ4Fxq_z7UjzZ4U7wEW0kMb4ZM4kQKzO9DEI-_0khX1vJuJPYGADhW-emoDr7oIdRPWeKAqBxAsxewZQTHeT1Y9-S48pGF-GYJwbeUWEOD_7QXSp0Qwd8IPu2jOVTnkbehbPSNOsre7FmPPi7_9_a2Ej1Zki-uHXiS6c7wflkIc4MmmTfMxZPazzC-c_UmVZBlux5SztgvLYJ1g3nDaqZ9yuALYkMbSPIxrnC1fiKhMnHOJLtMHPIDIxyZbWG5V23H_YPLuJpkKUSW0rT_hIwNKR_Ev3Ie09eABrWe_gCGZjaOKGDIn-DRbug1pr7yvBIN1iOf6PTdg"
			// Decode From Base64 => {"kid":"eXaunmL","alg":"RS256"}
			// Decode From Base64 => {"iss":"https://appleid.apple.com","aud":"com.ssflex.app.web","exp":1638939181,"iat":1638852781,"sub":"000686.dad1266e58474f8c873a28b504796298.0450","c_hash":"6-xmm8op9oQLokSNiMPxSw","email":"pjy@humanwares.com","email_verified":"true","auth_time":1638852781,"nonce_supported":true}
			const response = JSON.parse(atob((_result.detail.authorization.id_token).split('.')[1]));
			const uid = response.sub;
			let name;
			let email;

			if (_result.detail.user != null) {
				name = _result.detail.user.name.lastName + _result.detail.user.name.firstName;
				email = _result.detail.user.email;
			}

			if (response.email_verified == "true") {
				email = response.email;
			}

			console.log(response)
			console.log(email)
			console.log(name)

			console.log("get IOS Data")

			const self = this
			const delegateDomain = self.$route.params.subDomain

			self.axiosCaller.get(self, self.APIs.SNS_APPLE + "/doSnsLogin", {
				snsService: "apple",
				snsId: uid,
				email: email,
				name: name,
				deviceToken: (self.webUtils.isDom('#deviceToken')) ? document.querySelector('#deviceToken').value : "",
				LOGIN_DOMAIN: delegateDomain,
				coCode: delegateDomain
			}, async (res) => {
				const result = res.data
				console.log(result)

				if ( result.status === "integrated_login" ) {
					self.swalUtils.fire("계정 통합", result.msg, "info")
						.then(async swalResult => {
							console.log(swalResult)
							if (swalResult.isConfirmed || swalResult.dismiss) {
								if (await self.setSessionProc(result.coAccountVO)) {
									self.setSessionKeep(self.isKeepSession)
									if (window.opener) {
										self.$session.destroy()
										self.$nextTick(() => {
											window.opener.postMessage({ key: "apple", account: result.coAccountVO }, location.origin.replace(webUtils.getSubdomainWithURLString(location.href), delegateDomain))
											window.opener.focus()
											close()
										})
									} else {
										self.goWithCoCode(self)
									}
								}
							}
						});
					return
				}

				if (result.status === "login") {
					if (await self.setSessionProc(result.coAccountVO)) {
						self.setSessionKeep(self.isKeepSession);
						if (window.opener) {
							self.$session.destroy()
							window.opener.postMessage({ key: "apple", account: result.coAccountVO }, location.origin.replace(webUtils.getSubdomainWithURLString(location.href), delegateDomain))
							self.$nextTick(() => {
								window.opener.focus()
								close()
							})
						} else {
							self.goWithCoCode(self)
						}
					}
				} else {
					if (window.opener) {
						window.opener.postMessage({
							"key": "alert",
							"icon": "info",
							"title": "Error",
							"content": result.msg
						}, location.origin.replace(webUtils.getSubdomainWithURLString(location.origin), delegateDomain))
						self.$nextTick(() => {
							window.opener.focus()
							close()
						})
					} else {
						self.swalUtils.gritter("Error", result.msg, "question", 1500, () => {
							history.back()
						})
					}
				}
			})
			console.log("callback parameter: " + uid)
		},
	}, watch: {
		isLoaded: function() {
			document.querySelector('#appleid-signin').click()
		}
	}
}
</script>

<style scoped>

</style>